<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
</script>

<template>
    <AccordionItem value="reports" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'file-chart-line']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Reports</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs">
            <div class="flex flex-col text-white">
                <RouterLink to="/reports/glance" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >At a glance</RouterLink
                >
                <RouterLink to="/reports/customers" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Customers</RouterLink
                >
                <RouterLink to="/reports/rates" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Rates</RouterLink
                >
                <RouterLink
                    to="/reports/billing-excluded"
                    class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Billing excluded</RouterLink
                >
                <!-- <RouterLink to="/reports/invoices" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Invoices</RouterLink
                > -->
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
